/*  ========================================================================
    # Sections - Solutions - Index
    ========================================================================  */

import React from 'react';
import { createRoot } from 'react-dom/client';
import Solutions from './Solutions';

const containers = document.querySelectorAll('div[data-react-app="Solutions"]');

for (let i = 0; i < containers.length; i++) {
  const containerGuid = containers[i].attributes['data-guid']?.value;
  const props = window.reactProps[containerGuid];

  createRoot(containers[i]).render(<Solutions {...props} />);
}
